import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["title", "aria-label", "aria-expanded"]
const _hoisted_2 = {
  key: 0,
  class: "absolute left-1/2 top-1/2 h-px w-8 -translate-x-1/2 -translate-y-1/2 -rotate-45 bg-gray-400",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "text-[10px] leading-none text-gray-500" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "mb-2.5 flex items-center justify-between gap-2" }
const _hoisted_6 = { class: "truncate text-xs font-semibold text-gray-900" }
const _hoisted_7 = { class: "mt-3 grid grid-cols-6 gap-1.5" }
const _hoisted_8 = ["title", "aria-label", "onClick"]
const _hoisted_9 = { class: "mt-3 flex items-center justify-between border-t border-gray-100 pt-2.5" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "font-mono text-xs text-gray-400" }

import { XMarkIcon } from '@heroicons/vue/20/solid'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { ColorPicker } from 'vue-accessible-color-picker'

import { normalizeHex, PRESET_COLORS } from './websiteColors'


export default {
  __name: 'ColorSwatch',
  props: {
  modelValue: { type: String, default: null },
  defaultValue: { type: String, default: null },
  site: { type: String, default: '#FFFFFF' },
  label: { type: String, required: true },
  caption: { type: String, required: true }
},
  emits: ['update:modelValue', 'toggle'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const root = ref(null)
const open = ref(false)

watch(open, isOpen => emit('toggle', isOpen))

const shown = computed(() => props.modelValue || props.site)
const isDefault = computed(() => (props.modelValue || null) === (props.defaultValue || null))

const pick = event => {
  const hex = normalizeHex(event.colors.hex)
  if (hex && hex !== normalizeHex(shown.value)) emit('update:modelValue', hex)
}

const closeOnOutside = event => {
  if (open.value && root.value && !root.value.contains(event.target)) open.value = false
}

const closeOnEscape = event => {
  if (event.key === 'Escape') open.value = false
}

onMounted(() => {
  document.addEventListener('mousedown', closeOnOutside)
  document.addEventListener('keydown', closeOnEscape)
})

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', closeOnOutside)
  document.removeEventListener('keydown', closeOnEscape)
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "relative flex flex-col items-center gap-1"
  }, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["relative h-7 w-7 overflow-hidden rounded-full shadow-sm transition-transform hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-catering-honey-500 focus-visible:ring-offset-1", __props.modelValue ? 'ring-1 ring-inset ring-black/10' : 'border border-dashed border-gray-400 bg-white']),
      style: _normalizeStyle(__props.modelValue ? { background: __props.modelValue } : null),
      title: __props.modelValue || 'Matches your site',
      "aria-label": `${__props.label}: ${__props.modelValue || 'matches your site'}`,
      "aria-expanded": open.value,
      onClick: _cache[0] || (_cache[0] = $event => (open.value = !open.value))
    }, [
      (!__props.modelValue)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2))
        : _createCommentVNode("", true)
    ], 14, _hoisted_1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.caption), 1),
    (open.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "absolute right-0 top-full z-30 mt-2 w-64 rounded-xl border border-gray-200 bg-white p-3 text-left shadow-lg",
          role: "dialog",
          "aria-label": __props.label
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(__props.label), 1),
            _createElementVNode("button", {
              type: "button",
              class: "text-gray-400 hover:text-gray-700",
              "aria-label": "Close",
              onClick: _cache[1] || (_cache[1] = $event => (open.value = false))
            }, [
              _createVNode(_unref(XMarkIcon), {
                class: "h-4 w-4",
                "aria-hidden": "true"
              })
            ])
          ]),
          _createVNode(_unref(ColorPicker), {
            class: "bottle-color-picker",
            color: shown.value,
            "visible-formats": ['hex'],
            "default-format": "hex",
            "alpha-channel": "hide",
            onColorChange: pick
          }, null, 8, ["color"]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PRESET_COLORS), (preset) => {
              return (_openBlock(), _createElementBlock("button", {
                key: preset,
                type: "button",
                class: _normalizeClass(["h-6 rounded-md ring-inset transition-transform hover:scale-110", preset === __props.modelValue ? 'ring-2 ring-gray-900' : 'ring-1 ring-black/10']),
                style: _normalizeStyle({ background: preset }),
                title: preset,
                "aria-label": `Use ${preset}`,
                onClick: $event => (emit('update:modelValue', preset))
              }, null, 14, _hoisted_8))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              class: "text-xs font-medium text-gray-500 hover:text-gray-900 disabled:cursor-default disabled:text-gray-300",
              disabled: isDefault.value,
              onClick: _cache[2] || (_cache[2] = $event => (emit('update:modelValue', __props.defaultValue)))
            }, _toDisplayString(__props.defaultValue ? 'Reset to default' : 'Match my site'), 9, _hoisted_10),
            _createElementVNode("span", _hoisted_11, _toDisplayString(__props.modelValue || 'Site'), 1)
          ])
        ], 8, _hoisted_4))
      : _createCommentVNode("", true)
  ], 512))
}
}

}